import _ from 'lodash'
const MAX_NUMBERS_OF_CHARS = 200
export default {
  methods: {
    truncate (str = '', length = MAX_NUMBERS_OF_CHARS) {
      return _.truncate(str, { length })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/truncate.mixin.js